<template>
    <div class = "portals">
        <div v-if="showNoPortalsError" class="alert alert-warning" id="error-container" role="alert">
            <div class = "error-columns">
                <div class = "error-left-column">
                    <i class = "glyphicon glyphicon-alert"> </i>
                </div>
                <div v-if="this.adminLoginOnly" class = "error-right-column">
                    <strong class = "error-header"> No admin access for {{email}} </strong>
                    <div class = "error-content">
                        Unfortunately, you are not an <i> administator </i> of any Go1 portals. You can request permission from an
                        administrator, or sign in with an account which does have admin access.
                    </div>
                    <button v-on:click="logout" class = "btn btn-warning">
                        Sign in with another account
                    </button>
                </div>
                <div v-else class = "error-right-column">
                    <strong class = "error-header"> No portals available for {{email}} </strong>
                    <div class = "error-content">
                        Unfortunately, you do not have any Go1 portal available. You can request an invitation from an
                        administrator, or sign in with another account.
                    </div>
                    <button v-on:click="logout" class = "btn btn-warning">
                        Sign in with another account
                    </button>
                </div>
            </div>
        </div>

        <div v-if="!loadingPortals" class = "portal-lister-container">
            <div>
                <h3 v-if="!showNoPortalsError">
                    Which Go1 portal did you want to authorize?
                </h3>
                <div class = "portals-container">
                    <portal v-for="(portal, index) in sortedPortals" :portal="portal" :key="index">

                    </portal>
                </div>
            </div>
        </div>

        <div v-if="loadingPortals" class = "loading-spinner-container">
             <i class="fa fa-spin fa-circle-o-notch"></i>
        </div>

    </div>
</template>

<script>
import PortalService from '../../services/PortalService'
import AuthService from '../../services/AuthService'
import Portal from './Portal'

export default {

    data () {
        return {
            portals: [],
            loadingPortals: true,
        }
    },

    computed: {
        adminLoginOnly() {
            return this.$store.state.admin_login_only;
        },
        /*
        * Sort portals by availability and name
        */
        sortedPortals () {
            return this.portals.slice().sort( (portalA, portalB) => {
                let available = this.isPortalAvailable(portalB) - this.isPortalAvailable(portalA);
                if (available !== 0) {
                    return available;
                }

                return portalA.name.localeCompare(portalB.name);
            });
        },

        // grab email from session
        email () {
            return AuthService.getSession().mail;
        },

        // determine whether to show the no admin access to portals error
        showNoPortalsError () {
            return !this.loadingPortals && this.selectablePortals.length === 0;
        },

        selectablePortals () {
            return this.portals.filter(this.isPortalAvailable);
        }
    },

    components: {
        'portal': Portal
    },

    methods: {
        isPortalAvailable (portal) {
            return portal.is_admin || this.adminLoginOnly === false;
        },
        //if only one available portal, skip the selection process and go straight to auth for this portal
        checkAvailablePortals () {
            if (this.selectablePortals.length === 1) {
                this.$router.push({
                    name: 'portal_auth',
                    params: {
                        portal_id: this.selectablePortals[0].id,
                        portal_name: this.selectablePortals[0].name,
                        portal_url: this.selectablePortals[0].url
                    }
                });
            }
        },
        // Delete session, route back to login
        logout () {
            AuthService.logout();
            this.$router.push({name: 'login'});
        }
    },

    created () {
        // get portals
        PortalService.portals()
            .then(portals => {
                let { fixed_portal_id } = this.$store.state;
                if (!fixed_portal_id) {
                    return portals;
                }
                return portals.filter(portal => portal.id == fixed_portal_id);
            })
            .then(portals => {
                this.portals = portals;
                this.checkAvailablePortals();
                this.loadingPortals = false;
            }, () => this.loadingPortals = false);
    }
}
</script>

<style scoped>
    .portal-lister-container{
        text-align: left;
    }
    .error-columns{
        display: flex;
    }
    .error-left-column{
        width: 25%;
        color: #F5891C;
        font-size: 20px;
    }
    .error-header{
        margin-bottom: 30px;
        padding-bottom: 500px;
    }
    .error-content{
        margin-top: 5px;
        margin-bottom: 10px;
    }
    #error-container{
        margin-top: 20px;
    }
    .portal-lister-container h3{
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Portal/PortalLister.vue